export default "__VITE_ASSET__CWD0zhdl__"